import React  , { Component } from 'react'

import { HomeSlider, HomeTitle , FaqItem } from '../../Components/UI/UI'

import { getWeather, asyncgetWeather } from "../../Utility/Utility";
import {  faqData } from "../../Data/Data";
import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'



class FAQ extends Component {

  state = {
    faq : faqData, 
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,

  }

  setCurrentFaq = (id) => {
    const faq = [...this.state.faq];
    const current = faq.find( (o)=>{
      return o.id === id;
    });
    if ( current.isOpen=== true ) {
      current.isOpen = false;
    } else {
      current.isOpen = true;
    }
    this.setState({
      faq : faq
    })

  }

  componentDidMount () {

    Promise.all([ asyncgetWeather() ]).then( response => {
      const weather = response[0];
         // console.log( typeof weather);
      // console.log( weather);
    
      var weather2 = weather;

      
      if (typeof weather === 'string' && weather.includes("float")) {
        // Variable is a string
        // console.log('Is float in string');
        const str = weather.substring(weather.indexOf("{") + 1);
        const str2 = "{" + str;
        // console.log(str2);
        weather2 = JSON.parse(str2);

      
      } else if (typeof weather === 'object' && weather !== null) {
        // Variable is an object
        // console.log('Variable is an object');
        weather2 = weather.data;
        // console.log(weather2);
       
      } else if (typeof weather === 'string' && !weather.includes("float")){
        // console.log('Is NOt  float in string');
        const str = weather.substring(weather.indexOf("{") + 1);
        const str2 = "{" + str;
        // console.log(str2);
        weather2 = JSON.parse(str2);
     
      }

      //  else {
      //   // Variable is neither a string nor an object
      //   console.log('Variable is neither a string nor an object');
      // }

      this.setState({ 
        deadSeaWeather: weather2.deadsea.temperature,
        jerusalemWeather: weather2.jerusalem.temperature,
        telAvivWeather: weather2.telaviv.temperature,
        waterTemp: weather2.telaviv.water_temp,
      });
    });
    

     
  }
  
  render(){

     const faqHtml= this.state.faq.map((o)=>{
    
      return <FaqItem q={o.q} answer={o.answer} isOpen={o.isOpen} click={ () => {
        this.setCurrentFaq(o.id);
      }} />

    });
    return(
      <div className="page align-center page-FAQ inner-page">
        <Menu />
        <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />
        <div className="container">
           <HomeTitle>
            FAQ
            </HomeTitle>
            <div className="clear"></div>
            
            <div className="faq-wrapper">
                {faqHtml}
            </div>
            <div className="clear"></div>
        </div>
        <Footer />
      </div>
    )
  }

}



export default FAQ


// WEBPACK FOOTER //
// ./src/Pages/FAQ/FAQ.js